function ListQuartetColumnIcon(props) {
    return (
        <svg
            width={12}
            height={12}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fill={`${props.fill || '#BEBEBE'}`}
                d="M0 0h3v3H0zM0 9h3v3H0zM9 0h3v3H9zM9 9h3v3H9zM4.5 0h3v3h-3zM4.5 9h3v3h-3zM0 4.5h3v3H0zM9 4.5h3v3H9zM4.5 4.5h3v3h-3z"
            />
        </svg>
    );
}

export default ListQuartetColumnIcon;
